export default __webpack_public_path__ + "static/charts-e5db0c197e933d6c06a8fa90aba38dfb.jpg";